import React from 'react';
import { getText } from '../../utils/functions';

function FormLabel({
	text,
	translate,
	colors,
	portal,
	/* Optional Props */
	className = 'w-max font-bold text-lg md:text-2xl w-full',
	className2 = 'w-max font-bold text-lg md:text-sm w-full',
	style,
	noGetText = false
}) {
	/* Default values for the styles */
	const defaultStyle = {
		color: colors?.text,
	};
	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyle = { ...defaultStyle, ...style };

	return <>
		<div>
			<label className={className} style={overrideStyle}>
				{noGetText ? text : getText(text, translate)}
			</label>
		</div>
		{portal && portal.name === 'mutualmedica' &&
			<div style={{ marginTop: '1em' }}>
				<label className={className2} style={overrideStyle}>({translate.mutual_info})</label>
			</div>
		}
	</>;
}

export default FormLabel;
